/** Roles that can use staff/tenant operational pages (bookings, customers, POS, etc.). */
export const STAFF_PORTAL_ROLES = [
  'TENANT_ADMIN',
  'MANAGER',
  'SUPERVISOR',
  'STAFF',
] as const

export type StaffPortalRole = (typeof STAFF_PORTAL_ROLES)[number]

export function isStaffPortalRole(role?: string | null): boolean {
  if (!role) return false
  const normalized = role.toUpperCase()
  return (STAFF_PORTAL_ROLES as readonly string[]).includes(normalized)
}

/** AppLayout-friendly role list for operational staff pages. */
export const STAFF_PORTAL_ALLOWED_ROLES: string[] = [...STAFF_PORTAL_ROLES]

/** All authenticated roles subject to inactivity timeout (RL-020). */
export const ALL_TIMEOUT_ROLES = new Set([...STAFF_PORTAL_ROLES, 'CUSTOMER', 'PLATFORM_ADMIN'])
